import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { useFormikContext } from 'formik';
import { useField } from 'formik';
import MzErrorMessage from './MzErrorMessage';
import MzRadioButton from '../MzRadioButton';


function MzFormRadioButtonGroup({ name, label, options, onChange }) {
    const [field, , helpers] = useField(name);
    const { touched, errors } = useFormikContext();
    const { setValue } = helpers;

    const handleChange = (e) => {
        setValue(e.value);
        if(onChange)
            onChange(e.value);
    };

    return (
        <div className="field mt-1  w-full">
            <label>{label}</label>
            <div className='flex row gap-1'>
                {options.map((option, index) => (
                    <div key={index} className="gap-1  w-full field-radiobutton">
                        <MzRadioButton  inputId={`${name}-${index}`} name={name} value={option.value} onChange={handleChange} label={option.label} stateValue={field.value} setStateValue={setValue} />
                    </div>
                ))}
              
            </div>
            <MzErrorMessage error={errors[name]} visible={touched[name]} />
            
        </div>
    );
}

export default MzFormRadioButtonGroup;
